import styled from 'styled-components';

const Content = styled.div`
    flex: 1;
    width: 100%;
    p {
        margin-bottom: 20px;
        text-align: justify;
        &:last-of-type {
            margin-bottom: 0;
        }
    }
    iframe {
        max-width: 100%;
    }
`;

export default Content;



// WEBPACK FOOTER //
// ./src/layouts/components/Content.js